import React from 'react';
import QuotationBroucher from './QuotationBroucher';

function ProductCatalogPrint({ componentRef, catalogDetails, image }) {
  return (
    <div ref={componentRef} style={{ padding: 20 }}>
      <QuotationBroucher catalogDetails={catalogDetails} image={image}/>
    </div>
  );
}

export default ProductCatalogPrint;
